<template>
  <div class="d-flex align-items-center">
    <span
      v-if="text"
      class="soha-divider-text"
    >
      {{ text }}
    </span>
    <div class="soha-divider-border" />
  </div>
</template>

<script>
import "@/assets/css/components/base/divider.css";
export default {
  name: "Divider",
  props: {
    text: String,
  },
};
</script>
